import { CartSavingsItem } from '@/components/CartSheet/_components/CartSheetSavings/CartSavingsItem'
import T, { useTranslate } from '@/components/Helpers/Translate'
import { getFixedCurrency } from '@/lib/utils/numbers/getFixedCurrency'
import type { CartItemType } from '@/store/types/cart'
import useGlobalStore from '@/store/useGlobalStore'
import { getTerms } from '@/lib/hooks/services/useGetTerms'

type Props = {
  itemToAddToSubscription: CartItemType
}

export const ConfirmAddToActiveSubscriptionSavings = ({
  itemToAddToSubscription,
}: Props) => {
  const {
    user: { customerType },
  } = useGlobalStore()

  const { translate } = useTranslate()

  const customerPricing = getTerms({
    pricingData: itemToAddToSubscription.product.pricing,
    forCustomerType: 'Customer',
  })

  const customerTypePricing = getTerms({
    pricingData: itemToAddToSubscription.product.pricing,
    forCustomerType: customerType,
  })

  const customerTypeDiscount =
    customerPricing?.priceEach && customerTypePricing?.priceEach
      ? customerPricing.priceEach - customerTypePricing.priceEach
      : 0

  const subscriptionDiscount = itemToAddToSubscription.subscriptionDiscount || 0

  if (customerType === 'Customer') return null

  return (
    <div className="rounded-xl bg-blue-100 p-5">
      <p className="font-bold text-primary">
        <T>your_savings</T>:
      </p>
      {customerTypeDiscount > 0 && (
        <CartSavingsItem
          description={`${translate(
            customerType.toLocaleLowerCase(),
          )} ${translate('discount')}`}
          amount={getFixedCurrency({ amount: customerTypeDiscount })}
        />
      )}
      {subscriptionDiscount > 0 && (
        <CartSavingsItem
          description={translate('subscription_discount')}
          amount={getFixedCurrency({ amount: subscriptionDiscount })}
        />
      )}
    </div>
  )
}
